import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-incident as-incident__tennis"
}
const _hoisted_2 = {
  key: 0,
  class: "as-incident__head"
}
const _hoisted_3 = { class: "as-wrapper-player" }
const _hoisted_4 = {
  key: 1,
  class: "as-incident__list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "as-incident_row" }
const _hoisted_7 = { class: "as__left" }
const _hoisted_8 = {
  key: 0,
  class: "as-item-left as-item-left__top"
}
const _hoisted_9 = {
  key: 0,
  class: "as__live"
}
const _hoisted_10 = {
  key: 1,
  class: "as-item-left as-item-left__bottom"
}
const _hoisted_11 = {
  key: 0,
  class: "as__live"
}
const _hoisted_12 = { class: "as__right" }
const _hoisted_13 = {
  key: 0,
  class: "as-item-right as-item-right__top"
}
const _hoisted_14 = {
  key: 1,
  class: "as-item-right as-item-right__bottom"
}

import { ref, computed } from "vue";
import { mapPlayer } from "~src/helpers/tennis";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import NoData from "~src/components/NoData.vue";
import TennisLive from "~src/components/icons/TennisLive.vue";
import PlayerTennis from "~src/components/player/PlayerTennis.vue";
import PlayerTennisNew from "~src/components/player/PlayerTennisNew.vue";
import type {
  IStatisticsJsonData,
  IMatchTennis,
  ITimeline,
  ITimelineRound,
  IHighestRanking,
  IScoreDynamic,
} from "~src/interfaces/tennis";

import {
  getMappingTimelinesOverViews,
  getScoreForSet,
} from "~src/helpers/tennis";


const __default__ = {};

interface IProps {
  match: IMatchTennis;
  isPopup: boolean;
  detailShooting: any;
  overviews: IStatisticsJsonData[];
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DetailPointList',
  props: {
    match: {},
    isPopup: { type: Boolean, default: true },
    detailShooting: {},
    overviews: {}
  },
  setup(__props: any) {

const props = __props;

const findMaxPoint = computed<any>(() => {
  const _row = rows.value;
  const _match = props.match;

  let homeRanking = "0";
  let awayRanking = "0";
  if (_row?.score) {
    const scoreDynamic = _row?.score?.[3] as IScoreDynamic | undefined;
    if (scoreDynamic && scoreDynamic.pt) {
      homeRanking = scoreDynamic.pt[0];
      awayRanking = scoreDynamic.pt[1];
    }
  }

  return {
    home: homeRanking || 0,
    away: awayRanking || 0,
  };
});

const rows = computed<IStatisticsJsonData>(() => {
  const __rows = props.overviews.length
    ? props.overviews[props.overviews.length - 1]
    : ({} as IStatisticsJsonData);

  return __rows;
});

const timelines = computed<ITimeline[]>(() => {
  const rowData = rows.value;
  let __timeline = rowData.timeline ?? ([] as ITimeline[]);
  __timeline = getMappingTimelinesOverViews(__timeline);
  return __timeline;
});

// player1Score: Điểm số của người chơi 1 (home).
// player2Score: Điểm số của người chơi 2 (away).
// pointsArray: Mảng chứa tất cả các pha (points) của game hiện tại.
// currentPointIndex: Chỉ số của pha hiện tại trong mảng pointsArray.
// checkingPlayer: Người chơi đang được kiểm tra điều kiện (1 cho người chơi 1, 2 cho người chơi 2).
const isWinningPointCondition = function (
  player1Score: any,
  player2Score: any,
  pointsArray: any,
  currentPointIndex: any,
  checkingPlayer: any
) {
  // Nếu đang ở điểm đầu tiên (chỉ số bằng 0)
  if (currentPointIndex === 0) {
    return (
      (player1Score > player2Score && checkingPlayer === 1) ||
      (player1Score < player2Score && checkingPlayer === 2)
    );
  }

  // Kiểm tra điều kiện lợi thế
  if (
    (player1Score === "A" && checkingPlayer === 1) ||
    (player2Score === "A" && checkingPlayer === 2)
  ) {
    return true;
  }

  // Lấy điểm số của pha trước đó
  const previousPlayer1Score = pointsArray[currentPointIndex - 1][0];
  const previousPlayer2Score = pointsArray[currentPointIndex - 1][1];

  // So sánh điểm số giữa người chơi 1 và người chơi 2
  if (player1Score !== player2Score) {
    return (
      (player1Score !== previousPlayer1Score && checkingPlayer === 1) ||
      (player2Score !== previousPlayer2Score && checkingPlayer === 2)
    );
  } else if (player1Score === "40" && player2Score === "40") {
    if (previousPlayer1Score === "A") {
      return checkingPlayer === 2;
    } else if (previousPlayer2Score === "A") {
      return checkingPlayer === 1;
    }
    return (
      (player1Score !== previousPlayer1Score && checkingPlayer === 1) ||
      (player2Score !== previousPlayer2Score && checkingPlayer === 2)
    );
  } else {
    return (
      (player1Score !== previousPlayer1Score && checkingPlayer === 1) ||
      (player2Score !== previousPlayer2Score && checkingPlayer === 2)
    );
  }
};

// player1Score: Điểm số của người chơi 1 (home).
// player2Score: Điểm số của người chơi 2 (away).
// servingPlayer: Người chơi hiện đang giao bóng (1 cho người chơi 1, 2 cho người chơi 2).
// checkingPlayer: Người chơi cần kiểm tra điều kiện (1 cho người chơi 1, 2 cho người chơi 2).
const checkAdvantageCondition = function (
  player1Score: any,
  player2Score: any,
  servingPlayer: number,
  checkingPlayer: number
) {
  // Kiểm tra nếu người chơi 1 (home) đang giao bóng và kiểm tra người chơi 2 (away)
  if (servingPlayer === 1 && checkingPlayer === 2) {
    return (
      player2Score === "A" || // Người chơi 2 có điểm lợi thế
      (player2Score === "40" && // Người chơi 2 có điểm "40"
        player1Score !== "40" && // Người chơi 1 không có điểm "40"
        player1Score !== "A") // Người chơi 1 không có điểm lợi thế
    );
  }

  // Kiểm tra nếu người chơi 2 (away) đang giao bóng và kiểm tra người chơi 1 (home)
  if (servingPlayer === 2 && checkingPlayer === 1) {
    return (
      player1Score === "A" || // Người chơi 1 có điểm lợi thế
      (player1Score === "40" && // Người chơi 1 có điểm "40"
        player2Score !== "40" && // Người chơi 2 không có điểm "40"
        player2Score !== "A") // Người chơi 2 không có điểm lợi thế
    );
  }

  // Mặc định trả về false nếu không thỏa mãn các điều kiện trên
  return false;
};

const getClass = (round: any, index: number, type = "home") => {
  const points: any = round.points;
  const homeScore = points[index][0];
  const awayScore = points[index][1];
  const checkAdvantage = checkAdvantageCondition(
    homeScore,
    awayScore,
    round.score && round.score.serve ? round.score.serve : 1,
    type == "home" ? 1 : 2
  );
  if (checkAdvantage) {
    return "as__green";
  }

  const isWinning = isWinningPointCondition(
    homeScore,
    awayScore,
    points,
    index,
    type == "home" ? 1 : 2
  );
  if (isWinning) {
    return "as__white";
  }

  return "";
};

const activeCollapse = ref("0");

const changeActiveCollapse = (index: any) => {
  if (activeCollapse.value === index) {
    activeCollapse.value = "";
  } else {
    activeCollapse.value = index;
  }
};

return (_ctx: any,_cache: any) => {
  return (rows.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (rows.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(PlayerTennisNew, {
                  team: _ctx.match.home_team,
                  match: _ctx.match,
                  scores: findMaxPoint.value.home,
                  country: _ctx.getImgUrlBySport('country', _ctx.match.home_team.country_id)
                }, null, 8, ["team", "match", "scores", "country"]),
                _createVNode(PlayerTennisNew, {
                  team: _ctx.match.away_team,
                  match: _ctx.match,
                  modeTeam: "away-team",
                  scores: findMaxPoint.value.away,
                  country: _ctx.getImgUrlBySport('country', _ctx.match.away_team.country_id)
                }, null, 8, ["team", "match", "scores", "country"])
              ])
            ]))
          : _createCommentVNode("", true),
        (timelines.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelines.value, (timeline, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "as-incident__item"
                }, [
                  _createElementVNode("h3", {
                    onClick: ($event: any) => (changeActiveCollapse(index.toString())),
                    class: _normalizeClass({
            'as-active': activeCollapse.value === index.toString(),
          })
                  }, [
                    _createElementVNode("span", null, "SET " + _toDisplayString(`${timeline.set}`) + _toDisplayString(_unref(getScoreForSet)(rows.value.score, timeline.set)), 1),
                    _createVNode(ArrowDown, { fill: "#4CF446" })
                  ], 10, _hoisted_5),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeline.rounds, (round) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (round.score)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createTextVNode(_toDisplayString(round.score.home) + " ", 1),
                                (round.score.serve == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                      _createVNode(TennisLive)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (round.score)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createTextVNode(_toDisplayString(round.score.away) + " ", 1),
                                (round.score.serve == 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createVNode(TennisLive)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          (round.points)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(round.points, (point, indexPointHome) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: _normalizeClass(getClass(round, indexPointHome, 'home')),
                                    key: indexPointHome
                                  }, _toDisplayString(point[0]), 3))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (round.points)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(round.points, (point, indexPointAway) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: _normalizeClass(getClass(round, indexPointAway, 'away')),
                                    key: indexPointAway
                                  }, _toDisplayString(point[1]), 3))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 512)), [
                      [_vShow, activeCollapse.value == index.toString()]
                    ])
                  }), 256))
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(NoData, { key: 2 }))
      ]))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})